import { createColumn, formatDateTime } from "../../utils/helpers";

export const useReconciliationErrorlogs = () => {
  const tableColumns = () => [
    createColumn("statement_id", true, "Statement ID"),
    createColumn("partner_code", true, "Partner Code"),
    createColumn("log_date", true, "Log Date"),
    createColumn("error_message", true, "Error Message"),
  ];

  const tableData = (data: any) => {
    if (!data || !Array.isArray(data)) return [];

    return data.map((item: any) => ({
      ...item,
      log_date: formatDateTime(item.log_date),
    }));
  };

  return {
    tableColumns,
    tableData,
  };
};
